import { OrderState } from './order-state';
import { StyleHelper } from '../helpers/style-helper';

export class OrderStateItem {
  state: OrderState;
  text: string;
  backgroundColor: string;
  foregroundColor: string;

  constructor(state: OrderState, text: string, backgroundColor: string, foregroundColor: string) {
    this.state = state;
    this.text = text;
    this.backgroundColor = backgroundColor;
    this.foregroundColor = foregroundColor;
  }

  public getStyle(): string {
    return StyleHelper.getColorStyle(this.backgroundColor, this.foregroundColor);
  }
}
